<template>
  <div class="my-3">
    <DatePicker
      class="mt-3"
      v-if="info.extension_info.type === $defines.Part_Item_Date_Date"
      v-model="test"
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="d-flex align-items-center col-6 position-relative">
          <CFormInput :value="inputValue" v-on="inputEvents" readonly />
          <img
            class="calendar-img position-absolute"
            src="@/assets/icons/calendar.svg"
          />
        </div>
      </template>
    </DatePicker>

    <DatePicker
      class="mt-3"
      v-if="info.extension_info.type === $defines.Part_Item_Date_Date_And_Time"
      v-model="test"
      mode="dateTime"
      is24hr
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="d-flex align-items-center col-6 position-relative">
          <CFormInput :value="inputValue" v-on="inputEvents" readonly />
          <img
            class="calendar-img position-absolute"
            src="@/assets/icons/calendar.svg"
          />
        </div>
      </template>
    </DatePicker>

    <DatePicker
      class="mt-3"
      v-if="info.extension_info.type === $defines.Part_Item_Date_Date_Interval"
      v-model="test"
      is-range
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="d-flex align-items-center">
          <div class="position-relative d-flex align-items-center">
            <CFormInput
              :value="inputValue.start"
              v-on="inputEvents.start"
              readonly
            />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
          ～
          <div class="position-relative d-flex align-items-center">
            <CFormInput
              :value="inputValue.end"
              v-on="inputEvents.end"
              readonly
            />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
        </div>
      </template>
    </DatePicker>

    <DatePicker
      class="mt-3"
      v-if="
        info.extension_info.type ===
        $defines.Part_Item_Date_Date_And_Time_Interval
      "
      v-model="test"
      is24hr
      mode="dateTime"
      is-range
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="d-flex align-items-center">
          <div class="position-relative d-flex align-items-center">
            <CFormInput
              :value="inputValue.start"
              v-on="inputEvents.start"
              readonly
            />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
          ～
          <div class="position-relative d-flex align-items-center">
            <CFormInput
              :value="inputValue.end"
              v-on="inputEvents.end"
              readonly
            />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
        </div>
      </template>
    </DatePicker>
  </div>
</template>
<script>
import { DatePicker } from 'v-calendar'
import { ref } from '@vue/reactivity'

export default {
  components: {
    DatePicker,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const test = ref('')
    return {
      test,
    }
  },
}
</script>
<style lang="scss" scoped>
.calendar-img {
  width: 20px;
  right: 5px;
}
</style>
